<app-lista-arquivos [categoria]="categoria" [miniMode]="true" [linhas]="10"  [acao]="acao" ></app-lista-arquivos>
